import React, { lazy } from 'react';
import { BookOpenIcon, CheckCircleIcon } from 'lucide-react';
export function ProductOverview() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-521">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-522">
        <div className="text-center mb-12" data-id="element-523">
          <BookOpenIcon className="w-12 h-12 text-emerald-700 mx-auto mb-4" data-id="element-524" />
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-525">
            Introducing: The Natural Remedy Survival Guide
          </h2>
          <p className="text-xl text-stone-700 mb-6" data-id="element-526">
            60 Natural Remedies You Can Make at Home for Immunity, Pain,
            Digestion & More
          </p>
          <p className="text-lg text-stone-600 max-w-3xl mx-auto" data-id="element-527">
            This isn't a Pinterest DIY list. It's a structured, proven,
            root-cause-focused system for real people with real health
            struggles.
          </p>
        </div>
        <div className="max-w-3xl mx-auto mb-12" data-id="element-528">
          <div className="overflow-hidden rounded-lg shadow-2xl" data-id="element-529">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4T2z1eQPShmYPWcMK57Wgq/Natural_Remedies_and_Herbal_Healing-1.png" alt="Natural Remedies and Herbal Healing" className="w-full h-auto object-cover" loading="lazy" data-id="element-530" />
          </div>
        </div>
        <div className="bg-emerald-50 rounded-xl p-8" data-id="element-531">
          <h3 className="text-2xl font-bold text-stone-900 mb-6 text-center" data-id="element-532">
            Inside, you'll learn how to make:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-533">
            {['Cold & sinus relief tonics', 'Herbal salves for pain & inflammation', 'Sleep-supporting teas', 'Gut & digestion remedies', 'Skin, sinus, and immunity boosters', 'Natural syrups, oils, tinctures & more'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-534">
                <CheckCircleIcon className="w-6 h-6 text-emerald-700 flex-shrink-0" data-id="element-535" />
                <p className="text-lg text-stone-700" data-id="element-536">{item}</p>
              </div>)}
          </div>
          <p className="text-center text-lg text-stone-700 mt-6 font-semibold" data-id="element-537">
            All from ingredients you already have — or can get at any grocery
            store.
          </p>
        </div>
      </div>
    </section>;
}